import { isMobileOnly } from 'react-device-detect'

import { TextProps } from '../components'

export const getMobileFontPreset = (preset: TextProps['preset']) => {
  switch (preset) {
    case 'h1':
      return isMobileOnly ? 'h1Mobile' : 'h1'
    case 'h2':
      return isMobileOnly ? 'h2Mobile' : 'h2'
    case 'h3':
      return isMobileOnly ? 'h3Mobile' : 'h3'
    case 'h5':
      return isMobileOnly ? 'h5' : 'h4'
    default:
      return preset
  }
}
